import React, { Component } from "react";

import PropTypes from "prop-types";

import { BrowserRouter } from "react-router-dom";
import MiniDrawer from "../Bar/VBar";
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import AdminRoutes from "./routes/AdminRoutes";
import AnonymousRoutes from "./routes/AnonymousRoutes";
import { Box } from "@material-ui/core";

const styles = (theme) => ({
  contentGrid: {
      paddingTop: 36
  },
  siteBarGrid: {
    // maxWidth: '2.333333%',
    minWidth: 'fit-content',
    marginLeft: '2.333333%',
  },
  siteBarExpandedGrid: {
    minWidth: 'fit-content',
    marginLeft: '15.666667%'
  }
});

class Router extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
       isExpanded: false,
       isPinned: false
    }
  }

  onToggle = (isExpanded) => {
    this.setState({ isExpanded: isExpanded });
  }

  pinMenu = (event) => {
    this.setState({ isPinned: event.target.checked });
  }

  userInRole = (roleName)=>{
    const {userData} = this.props;
    return userData && userData.roles && userData.roles.includes(roleName);
  }
  
  render() {
    // Properties
    const { user, userData, roles, theme, bar, classes, appSettings } = this.props;

    const { isExpanded, isPinned } = this.state;

    // Functions
    const { openSnackbar, openDialog, performingAction, signOutCall} = this.props;
    //baseName of BrowserRouter can be tenantId
    const anonymousRoutes = <BrowserRouter>
      <Grid container>
        <AnonymousRoutes
          openSnackbar={openSnackbar}
          theme={theme}
          appSettings={appSettings}
          />
      </Grid>
    </BrowserRouter>;

    const appRoutes =  <BrowserRouter>
      <Grid container>
        <Grid item xs={isExpanded ? 2 : 1}>
          { user && <MiniDrawer
                    onToggle={this.onToggle}
                    isExpanded={isExpanded}
                    isPinned={isPinned}
                    onPinned={this.pinMenu}
                    performingAction={performingAction}
                    theme={theme}
                    user={user}
                    userData={userData}
                    appSettings={appSettings}
                    roles={roles}
                    openSnackbar={openSnackbar}
                    onSignUpClick={() => openDialog("signUpDialog")}
                    onSignInClick={() => openDialog("signInDialog")}
                    onAboutClick={() => openDialog("aboutDialog")}
                    onSettingsClick={() => openDialog("settingsDialog")}
                    // onSignOutClick={() => openDialog("signOutDialog")}
                    onSignOutClick={() => signOutCall()}
                  />}
          </Grid>
        <Grid item xs={isExpanded ? 10 : 12}  className={isExpanded ? classes.siteBarExpandedGrid : classes.siteBarGrid}>
        <Box pt={2} pl={5}>
          { this.userInRole('ADMIN') && <AdminRoutes 
            user={user}
            userData={userData}
            appSettings={appSettings}
            roles={roles}
            openSnackbar={openSnackbar}
            theme={theme}/>
          }
        </Box>
        </Grid>
        </Grid>
      </BrowserRouter>
      
    return <>
      { user ? appRoutes : anonymousRoutes}
    </>
  }
}

Router.propTypes = {
  // Properties
  user: PropTypes.object,
  roles: PropTypes.array.isRequired,
  bar: PropTypes.element,
  theme: PropTypes.object,

  // Functions
  openSnackbar: PropTypes.func.isRequired,
};

export default withStyles(styles)(Router);
